import http from '../_http_v2';

const schedule = {
  //default
  list: (m) => { return http.post(`console/wmds/schedule/list`, m); },
  detail: (m) => { return http.get(`console/wmds/schedule/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wmds/schedule`, m); },
  update: (m) => { return http.put(`console/wmds/schedule`, m); },
  delete: (m) => { return http.delete(`console/wmds/schedule/${m.id}`); },
}

export default schedule

export { schedule }